import { Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

const AuthPageLayout = () => {
  return (
    <Flex
      flexDir="column"
      w="full"
      minH="100vh"
      position="relative"
      data-testid="auth-page-layout"
    >
      <Outlet />
    </Flex>
  );
};

export default AuthPageLayout;
